import { Button, Loading } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { useEffect } from 'react'
import { noop } from 'utils'
export type ResendLMSLegalRequestBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const ResendLMSLegalRequestBtn = ({
  disabled = false,
  userId,
  onDone = noop,
  onError = noop,
}: ResendLMSLegalRequestBtnProps) => {
  const [state, { resendLMSSignatureRequest }] = useAccountActions()
  useEffect(() => {
    if (state.matches('success')) {
      onDone('Legal signature request sent')
    } else if (state.matches('failed')) {
      onError(
        state.context?.error ||
          'Failed to resend legal signature request, please try again'
      )
    }
  }, [state, onDone, onError])
  return (
    <Button
      type="button"
      variant="buttons.primary"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
        flex: '0 0 auto',
      }}
      disabled={disabled || state.matches('syncing')}
      onClick={() => resendLMSSignatureRequest({ userId })}>
      {state.matches('syncing') ? <Loading /> : <span>Sign Agreement</span>}
    </Button>
  )
}
